export default "__VITE_ASSET__DJejW5TT__"